import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { ReactComponent as Logo } from "../../shared/Icons/logo.svg";
import tokenUtils from "utils";

import styles from "./Header.module.scss";

const handleOnClickLogoutButton = (navigate) => {
  Cookies.remove("jweToken");
  localStorage.clear();
  navigate("/login");
};

const Header = () => {
  const navigate = useNavigate();
  const loggedIn = tokenUtils.isValidUser();

  return (
    <div className={styles.headerContainer}>
      <div className={styles.headerRoutes}>
        <div className={styles.logoAndHomeIconContainer}>
          <Logo />
        </div>
      </div>
      {loggedIn && (
        <div
          className={styles.logOutButton}
          onClick={() => handleOnClickLogoutButton(navigate)}
        >
          Logout
        </div>
      )}
    </div>
  );
};

export default Header;
